import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";

import Contact from "./Contact";

// // script purely for form appearance on input
import "../js/form-script";

const headerNum = Math.round(Math.random() + 1);

class ContactPage extends React.Component {
  render() {
    return (
      <div className="App">
        <Header
          currentPage={this.props.currentPage}
          pages={this.props.pageData}
        />
        <div className="App__divider" />
        <img src={`../header-${headerNum}.jpg`} className="img-header" />
        <div className="row contact__container">
          <Contact />
        </div>
        <Footer blogInfo={this.props.blogInfo} />
      </div>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/components/ContactPage.js